const FR = {
  confirmButtonText: 'Confirmer',
  cancelButtonText: 'Annuler',
}

export { FR }
